<div class="wrapper">
  <h1 class="text-center"><a routerLink="/home">Stat</a></h1>

  <div class="container p-24">
    <h3>Create an account</h3>

    <!--    <button class="stretch mb-20">Sign up with google</button>-->

    <!--    <div class="text-line"><span>OR</span></div>-->

    <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
      <div *ngIf="!contact">
        <div>
          <label class="stretch" for="contact" translate>app.sign.email</label>
          <div style="display: flex;">
            <input class="stretch" placeholder="{{'app.sign.email-address' | translate}}..." type="text"
                   name="contact" formControlName="contact" id="contact"
                   [ngClass]="{ 'invalid': submitted && fg.contact.errors }"/>
          </div>

          <div class="stretch" *ngIf="submitted && fg.contact.errors">
            <div *ngIf="fg.contact.errors.required" translate>app.sign.contact.empty.error</div>
          </div>
        </div>

        <small class="text-justify stretch mt-10">The password for your account will be generated automatically</small>
        <button class="stretch mt-10 mb-10 blue" type="submit" [disabled]="loading" translate>app.sign.register</button>

        <small class="text-justify stretch">By signing up, I accept the <a routerLink="/terms-and-conditions">Stats
          Terms of Service</a> and acknowledge the <a routerLink="/privacy">Privacy Policy</a>.</small>
      </div>

      <div *ngIf="error">{{error}}</div>
    </form>

    <div *ngIf="contact">
      <p>Please check your email <strong>{{contact}}</strong> and follow the link inside email.</p>

      <button class="stretch mt-10 mb-10 blue" type="button" (click)="changeContact()" translate>Change email address
      </button>
    </div>
  </div>

  <div class="mt-20 text-center">
    Already have an account? <a routerLink="/sign-in" translate>app.sign.login</a>
  </div>
</div>
